"use client";

import Image from "next/image";
import { useRouter } from "next/navigation";
import { FC } from "react";

import StubImageSrc from "@/imgs/welcome_screen.png";
import { Button, Typography } from "@/shared/ui";

import styles from "./error.module.scss";

const NotFoundPage: FC = () => {
  const { back } = useRouter();

  return (
    <main className={styles.container}>
      <Image src={StubImageSrc} className={styles.welcomeImage} alt="welcome-image" />

      <div className={styles.content}>
        <div className={styles.top}>
          <Typography bold as="h1" variant="large-title" align="center">
            404 | This page could not be found.
          </Typography>
        </div>

        <div className={styles.bottom}>
          <Button size="big" variant="secondary" onClick={back}>
            Back
          </Button>
        </div>
      </div>
    </main>
  );
};

export default NotFoundPage;
